import { config } from "../../utils/constants";
import { getCurrentLocale } from "../../utils/util";
import { oAuthRequest } from "../../utils/request";
import { getLiferayUserId } from "../../utils/themeDisplay";

export const getAllServices = (userRoles) => {
  const locale = getCurrentLocale();
  const userId = getLiferayUserId();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.otherDashboardServices}all-services`,
    method: 'get',
    params: {
      locale,
      userId
    }
  };

  return oAuthRequest(requestConfig);
};
export const getUserType = () => {
  const requestConfig = {
    method: "POST",
    url: `${config.backendBaseAddress}${config.otherDashboardServices}user-type`
  };

  return oAuthRequest(requestConfig);
};

export const getEncryptedText = (id, persona, language) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.otherDashboardServices}encrypt`,
    method: 'get',
    params: {
      id,
      persona,
      language
    }
  };

  return oAuthRequest(requestConfig);
};